export default {"src":"/_next/static/media/testimonial-1.300ac90c.svg","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};